@if (stepInfo()) {
  <form [formGroup]="stepInfoForm()">
    <lib-accordion
      [accordionClass]="'p-lg bg-neutral-50 mb-2xl'"
      [title]="stepInfo().name"
      [isOpen]="!!stepInfo().isExpanded"
      [titleClass]="'font-semibold text-neutral-900 text-base'"
      [detailsClass]="'my-2xl px-lg'"
      [disableToggle]="disableExpand()"
      (toggleAccordion)="toggleAccordion(stepInfo())">
      <!-- step info header -->
      <div class="flex items-center justify-between mb-2xl">
        <h5 class="font-medium text-neutral-900 text-base">
          {{
            'workflow_configurations_details_screen_accordion_details_title'
              | transloco
          }}
        </h5>

        <!-- call to actions -->
        <div class="flex gap-sm">
          <button
            id="workflow_configurations_details_screen_discard_button"
            class="bg-transparent text-sm text-primary-600 font-medium py-sm px-lg cursor-pointer"
            type="button"
            (click)="discardChanges.emit()">
            {{
              'workflow_configurations_details_screen_discard_button'
                | transloco
            }}
          </button>

          <button
            id="workflow_configurations_details_screen_save_button"
            class="bg-primary-500 text-sm text-white font-medium py-sm px-lg rounded-md cursor-pointer disabled:opacity-50"
            type="button"
            [disabled]="stepInfoForm().invalid"
            (click)="submitForm.emit(stepInfo())">
            {{
              'workflow_configurations_details_screen_save_button' | transloco
            }}
          </button>
        </div>
      </div>

      <!-- step sections -->
      <div class="flex flex-col gap-sm">
        <!-- assignees info -->
        <section class="pt-lg pb-md gap-lg border-b border-neutral-200">
          <div class="flex gap-lg">
            <div class="w-40 font-medium text-sm text-neutral-900">
              {{
                'workflow_configurations_details_screen_assignees_info_section_title'
                  | transloco
              }}
            </div>

            <div class="flex flex-col flex-grow">
              <ng-container formArrayName="assignees">
                @for (
                  assignee of assigneeReferenceArray();
                  track assignee.id;
                  let index = $index;
                  let isFirst = $first
                ) {
                  <div
                    class="flex items-center justify-between"
                    [class]="
                      assigneeForm.controls.length > 1
                        ? 'border-b border-neutral-200'
                        : ''
                    "
                    [formGroupName]="index">
                    <div
                      class="flex flex-wrap gap-lg py-lg"
                      [class.py-lg]="!isFirst"
                      [class.pb-lg]="isFirst">
                      <div class="flex flex-col gap-x-sm w-100">
                        <div class="font-medium text-sm text-neutral-900">
                          {{
                            'workflow_configurations_details_screen_resource_type_label'
                              | transloco
                          }}
                        </div>

                        <div>
                          <lib-select
                            [inputFormControlName]="'assignable_type'"
                            id="assignable_type"
                            name="assignable_type"
                            [options]="assigneeTypeOptions()"
                            [selectedKeyName]="'label'"
                            [selectedKeyValue]="'value'"
                            [placeholder]="
                              'workflow_configurations_details_screen_type_placeholder'
                                | transloco
                            "
                            (changeOption)="changeAssignableType(index)"
                            [required]="true" />

                          <lib-validation-message
                            [lang]="'current_lang' | transloco"
                            control="assignable_type" />
                        </div>
                      </div>

                      @if (
                        assigneeControls[index].get('assignable_type')
                          ?.value === 'group' ||
                        assigneeControls[index].get('assignable_type')
                          ?.value === 'department' ||
                        assigneeControls[index].get('assignable_type')
                          ?.value === 'legal_entity'
                      ) {
                        @if (
                          assigneeControls[index].get('assignable_type')
                            ?.value === 'group' ||
                          assigneeControls[index].get('assignable_type')
                            ?.value === 'department'
                        ) {
                          <div class="flex flex-col gap-x-sm w-100">
                            <div class="font-medium text-sm text-neutral-900">
                              {{
                                'workflow_step_info_form_assignable_option_label'
                                  | transloco
                              }}
                            </div>
                            <div>
                              <lib-select
                                [inputFormControlName]="'option'"
                                id="option"
                                name="option"
                                [value]="
                                  assigneeControls[index].get('option')?.value
                                "
                                [options]="
                                  assigneeControls[index].get('assignable_type')
                                    ?.value === 'group'
                                    ? this.groupAssignableOption()
                                    : this.departmentAssignableOption()
                                "
                                [selectedKeyName]="'label'"
                                [selectedKeyValue]="'value'"
                                [placeholder]="
                                  'workflow_step_info_form_assignable_option_label'
                                    | transloco
                                "
                                (changeOption)="
                                  changeAssignableOption($event, index)
                                "
                                [required]="true" />

                              <lib-validation-message
                                [lang]="'current_lang' | transloco"
                                control="option" />
                            </div>
                          </div>
                        }
                      }

                      <!-- assignable type -->
                      @if (
                        assigneeControls[index].get('assignable_type')?.value
                      ) {
                        <div class="flex flex-col gap-x-sm w-100">
                          @if (
                            assigneeControls[index].get('assignable_type')
                              ?.value !== 'legal_entity' &&
                            assigneeControls[index].get('assignable_type')
                              ?.value !== 'variable' &&
                            assigneeControls[index].get('assignable_type')
                              ?.value !== 'project_role' &&
                            assigneeControls[index].get('assignable_type')
                              ?.value !== 'fields'
                          ) {
                            <div class="font-medium text-sm text-neutral-900">
                              <ng-container
                                [ngTemplateOutlet]="type"
                                [ngTemplateOutletContext]="{
                                  $implicit:
                                    assigneeControls[index].get(
                                      'assignable_type'
                                    )?.value,
                                }" />
                            </div>

                            <div>
                              <lib-customized-dropdown
                                [id]="'assignable_id'"
                                [inputFormControlName]="'assignable_id'"
                                [name]="'assignable_id'"
                                [placeholder]="
                                  assigneeSelectDependency()[index].placeholder
                                "
                                [apiUrl]="assigneeSelectDependency()[index].api"
                                [selectedOption]="
                                  assigneeSelectDependency()[index]
                                    .selectedOption
                                "
                                [filters]="
                                  assigneeSelectDependency()[index].filters
                                "
                                [searchLabel]="
                                  assigneeSelectDependency()[index].searchLabel
                                "
                                [searchPlaceholder]="
                                  assigneeSelectDependency()[index]
                                    .searchPlaceholder
                                "
                                [required]="true" />

                              <lib-validation-message
                                [lang]="'current_lang' | transloco"
                                control="assignable_id" />
                            </div>
                          } @else {
                            <lib-paginated-select
                              [id]="'assignable_id'"
                              [inputFormControlName]="'assignable_id'"
                              [name]="'name'"
                              [label]="assigneeLookupLabels()[index]"
                              [placeholder]="assigneeLookupLabels()[index]"
                              [apiUrl]="assigneeSelectDependency()[index].api"
                              [selectedOption]="
                                assigneeSelectDependency()[index].selectedOption
                              "
                              [noDataLabel]="
                                'user_dropdown_input_no_data_label' | transloco
                              "
                              [required]="true" />
                            <lib-validation-message
                              [lang]="'current_lang' | transloco"
                              control="assignable_id" />
                          }
                        </div>
                      }

                      <!-- assignees preference -->
                      @if (
                        assigneeControls[index].get('assignable_type')
                          ?.value === 'group' ||
                        assigneeControls[index].get('assignable_type')
                          ?.value === 'department' ||
                        assigneeControls[index].get('assignable_type')
                          ?.value === 'legal_entity'
                      ) {
                        @if (
                          assigneeControls[index].get('option')?.value !==
                          'manager'
                        ) {
                          <div class="flex flex-col gap-x-sm w-100">
                            <div class="font-medium text-sm text-neutral-900">
                              {{
                                'workflow_step_info_form_assignees_preference_label'
                                  | transloco
                              }}
                            </div>

                            <div>
                              <lib-select
                                [inputFormControlName]="'assignment_preference'"
                                id="assignment_preference"
                                name="assignment_preference"
                                [options]="assignmentPreferenceOptions()"
                                [value]="''"
                                [selectedKeyName]="'label'"
                                [selectedKeyValue]="'value'"
                                [placeholder]="
                                  'workflow_step_info_form_assignees_preference_placeholder'
                                    | transloco
                                "
                                (changeOption)="
                                  changeAssignmentPreference($event, index)
                                "
                                [required]="true" />

                              <lib-validation-message
                                [lang]="'current_lang' | transloco"
                                control="assignment_preference" />
                            </div>
                          </div>

                          @if (
                            assignmentPreferenceControl(index) === 'at_least'
                          ) {
                            <div class="flex flex-col gap-x-sm w-100">
                              <div>
                                <lib-input
                                  [inputFormControlName]="'preference'"
                                  [id]="'preference'"
                                  type="number"
                                  name="preference"
                                  [required]="true"
                                  [label]="
                                    'workflow_step_info_form_number_of_assignees_label'
                                      | transloco
                                  "
                                  [placeholder]="
                                    'workflow_step_info_form_number_of_assignees_label'
                                      | transloco
                                  "
                                  [required]="true" />
                                <lib-validation-message
                                  [lang]="'current_lang' | transloco"
                                  control="preference" />
                              </div>
                            </div>
                          }
                        }
                      }
                    </div>

                    <!-- delete assignee -->
                    @if (assigneeForm.length > 1) {
                      <button
                        type="button"
                        (click)="deleteFromGroupIndexEmitter.emit(index)"
                        id="workflow_step_info_form_delete_assignee_button"
                        class="bg-white text-primary-600 font-medium text-base py-md px-2xl border-none rounded-md size-6">
                        <lib-delete-icon
                          [iconClass]="'size-6 text-destructive-500'" />
                      </button>
                    }
                  </div>
                }
              </ng-container>

              <!-- add new assignee -->
              <button
                [disabled]="assigneeReferenceArray().length >= 5"
                (click)="addAssignee()"
                type="button"
                [class]="
                  'text-primary-600 bg-white font-medium text-sm pt-lg border-none flex gap-sm ' +
                  (assigneeReferenceArray().length >= 5
                    ? 'cursor-not-allowed opacity-30'
                    : '')
                "
                id="workflow_step_info_form_add_new_type_button_label">
                <lib-add-icon [iconClass]="'size-6 text-primary-500'" />

                {{
                  'workflow_step_info_form_add_new_type_button_label'
                    | transloco
                }}
              </button>
            </div>
          </div>
        </section>

        <!-- Assignment Preference -->
        <section class="flex py-lg gap-lg border-b border-neutral-200">
          <span class="w-40 font-medium text-sm text-neutral-900">
            {{
              'workflow_step_info_form_assignment_preference_label' | transloco
            }}
          </span>

          <div class="w-100">
            <p class="text-sm font-medium text-neutral-900 mb-x-sm">
              {{
                'workflow_step_info_form_assignment_preference_label'
                  | transloco
              }}
            </p>

            <lib-select
              [inputFormControlName]="'assignment_preference_type'"
              id="assignment_preference_type"
              name="assignment_preference_type"
              [options]="assignmentPreferenceTypeOptions()"
              [value]="''"
              [selectedKeyName]="'label'"
              [selectedKeyValue]="'value'"
              [placeholder]="
                'workflow_step_info_form_assignment_preference_placeholder'
                  | transloco
              "
              [required]="true" />

            <lib-validation-message
              [lang]="'current_lang' | transloco"
              control="assignment_preference_type" />
          </div>
        </section>

        <!-- sla -->
        <section class="flex py-lg gap-lg border-b border-neutral-200">
          <div class="w-40 font-medium text-sm text-neutral-900">
            {{
              'workflow_configurations_details_screen_sla_section_title'
                | transloco
            }}
          </div>

          <div class="w-[calc(100%-10rem)] gap-lg">
            <div class="flex flex-wrap gap-lg">
              <div class="w-100 flex flex-col gap-x-sm">
                <div class="font-semibold text-sm text-neutral-900">
                  {{ 'workflow_step_info_form_sla_type_label' | transloco }}
                </div>
                <lib-select
                  [inputFormControlName]="'sla_type'"
                  id="sla_type"
                  name="sla_type"
                  [options]="slaTypeOptions()"
                  [value]="stepInfo().sla.type"
                  [selectedKeyName]="'label'"
                  [selectedKeyValue]="'value'"
                  [placeholder]="''"
                  (changeOption)="changeSlaType($event)"
                  [required]="true" />

                <lib-validation-message
                  [lang]="'current_lang' | transloco"
                  control="type" />
              </div>

              @if (
                stepInfoForm().get('sla_type')?.value === slaTypeEnum.STATIC
              ) {
                <div class="w-100 flex flex-col gap-x-sm">
                  <div class="font-semibold text-sm text-neutral-900">
                    {{
                      'workflow_configurations_details_screen_estimated_completion_time_wh_label'
                        | transloco
                    }}
                  </div>
                  <lib-input
                    [inputFormControlName]="'sla'"
                    id="sla"
                    name="sla"
                    [type]="'number'"
                    [placeholder]="
                      'workflow_configurations_details_screen_estimated_completion_time_placeholder'
                        | transloco
                    "
                    [required]="true" />

                  <lib-validation-message
                    [lang]="'current_lang' | transloco"
                    control="sla" />
                </div>
              }

              @if (
                stepInfoForm().get('sla_type')?.value === slaTypeEnum.VARIABLE
              ) {
                <div class="w-100 flex flex-col gap-x-sm">
                  <div class="font-semibold text-sm text-neutral-900">
                    {{
                      'workflow_step_info_form_sla_variable_label' | transloco
                    }}
                  </div>
                  <div>
                    <lib-paginated-select
                      [id]="'sla_variable'"
                      [inputFormControlName]="'sla_variable'"
                      [name]="'sla_variable'"
                      [placeholder]="
                        'workflow_step_info_form_sla_variable_placeholder'
                          | transloco
                      "
                      [apiUrl]="slaVariableApi"
                      [selectedOption]="selectedSlaVariable()"
                      [noDataLabel]="
                        'user_dropdown_input_no_data_label' | transloco
                      "
                      [required]="true" />
                    <lib-validation-message
                      [lang]="'current_lang' | transloco"
                      control="sla_variable" />
                  </div>
                </div>
              }
            </div>
          </div>
        </section>

        <!-- escalations -->
        <section class="flex py-lg gap-lg border-b border-neutral-200">
          <p class="w-40 font-medium text-sm text-neutral-900">
            {{
              'workflow_configurations_details_screen_sla_escalations_section_title'
                | transloco
            }}
          </p>

          <div class="w-[calc(100%-10rem)] gap-lg" [formGroup]="escalationForm">
            <div class="flex gap-lg mb-lg">
              <div class="flex flex-col gap-x-sm w-100">
                <div class="font-semibold text-sm text-neutral-900">
                  {{ 'workflow_step_info_form_when_label' | transloco }}
                </div>

                <div>
                  @let whenControl = escalationForm.get('when');
                  @let whenRequired =
                    whenControl?.hasValidator(Validators.required);
                  <lib-select
                    [inputFormControlName]="'when'"
                    id="when"
                    name="when"
                    [options]="whenTypeOptions()"
                    [selectedKeyName]="'label'"
                    [selectedKeyValue]="'value'"
                    [placeholder]="
                      'workflow_step_info_form_when_placeholder' | transloco
                    "
                    [required]="!!whenRequired" />

                  <lib-validation-message
                    [lang]="'current_lang' | transloco"
                    control="when" />
                </div>
              </div>
              <div class="flex flex-col gap-x-sm w-100">
                <div class="font-semibold text-sm text-neutral-900">
                  {{
                    'workflow_configurations_details_screen_sla_escalations_section_title'
                      | transloco
                  }}
                </div>

                <div>
                  @let escalationTypeControl =
                    escalationForm.get('escalation_type');
                  @let escalationTypeRequired =
                    escalationTypeControl?.hasValidator(Validators.required);
                  <lib-select
                    [inputFormControlName]="'escalation_type'"
                    id="escalation_type"
                    name="escalation_type"
                    [options]="escalationTypeOptions()"
                    [value]="stepInfo().escalation?.type?.value"
                    [selectedKeyName]="'label'"
                    [selectedKeyValue]="'value'"
                    [placeholder]="
                      'workflow_step_info_form_sla_action_placeholder'
                        | transloco
                    "
                    [required]="!!escalationTypeRequired" />

                  <lib-validation-message
                    [lang]="'current_lang' | transloco"
                    control="escalation_type" />
                </div>
              </div>
            </div>

            <div class="flex gap-lg">
              <div class="flex flex-col gap-x-sm w-100">
                <div class="font-semibold text-sm text-neutral-900">
                  {{
                    'workflow_configurations_details_screen_resource_type_label'
                      | transloco
                  }}
                </div>

                <div>
                  @let stakeholderTypeRequired =
                    stakeholderTypeControl.hasValidator(Validators.required);
                  <lib-select
                    [inputFormControlName]="'stakeholder_type'"
                    id="stakeholder_type"
                    name="stakeholder_type"
                    [options]="stakeholderTypeOptions()"
                    [value]="
                      stepInfo().escalation?.stakeholder_type ||
                      stepInfo().escalation?.type?.value
                    "
                    [selectedKeyName]="'label'"
                    [selectedKeyValue]="'value'"
                    [placeholder]="
                      'workflow_configurations_details_screen_type_placeholder'
                        | transloco
                    "
                    [required]="!!stakeholderTypeRequired" />

                  <lib-validation-message
                    [lang]="'current_lang' | transloco"
                    control="stakeholder_type" />
                </div>
              </div>

              @if (stakeholderTypeControl.value) {
                @if (
                  stakeholderTypeControl.value !== escalationTypeEnum.VARIABLE
                ) {
                  <div class="flex flex-col gap-x-sm w-100">
                    <div class="font-semibold text-sm text-neutral-900">
                      <ng-container
                        [ngTemplateOutlet]="type"
                        [ngTemplateOutletContext]="{
                          $implicit: stakeholderTypeControl.value,
                        }" />
                    </div>
                    <div>
                      @let stakeholderIdControl =
                        escalationForm.get('stakeholder_id');
                      @let stakeholderIdRequired =
                        stakeholderIdControl?.hasValidator(Validators.required);
                      <lib-customized-dropdown
                        [id]="'stakeholder_id'"
                        [inputFormControlName]="'stakeholder_id'"
                        [name]="'stakeholder_id'"
                        [placeholder]="resourceSelectDependency().placeholder"
                        [apiUrl]="resourceSelectDependency().api"
                        [selectedOption]="
                          resourceSelectDependency().selectedOption
                        "
                        [filters]="resourceSelectDependency().filters"
                        [searchLabel]="resourceSelectDependency().searchLabel"
                        [searchPlaceholder]="
                          resourceSelectDependency().searchPlaceholder
                        "
                        [required]="!!stakeholderIdRequired" />

                      <lib-validation-message
                        [lang]="'current_lang' | transloco"
                        control="stakeholder_id" />
                    </div>
                  </div>
                } @else {
                  <div class="flex flex-col gap-x-sm w-100">
                    <div class="font-semibold text-sm text-neutral-900">
                      <ng-container
                        [ngTemplateOutlet]="type"
                        [ngTemplateOutletContext]="{
                          $implicit: stakeholderTypeControl.value,
                        }" />
                    </div>
                    <div>
                      @let variableControl = escalationForm.get('variable');
                      @let variableRequired =
                        variableControl?.hasValidator(Validators.required);
                      <lib-paginated-select
                        [id]="'variable'"
                        [inputFormControlName]="'variable'"
                        [name]="'variable'"
                        [placeholder]="
                          'workflow_step_info_form_escalation_variable_placeholder'
                            | transloco
                        "
                        [apiUrl]="escalationVariableApi"
                        [selectedOption]="selectedEscalationVariable()"
                        [noDataLabel]="
                          'user_dropdown_input_no_data_label' | transloco
                        "
                        [required]="!!variableRequired" />

                      <lib-validation-message
                        [lang]="'current_lang' | transloco"
                        control="variable" />
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        </section>

        <!-- when -->
        <section class="flex py-lg gap-lg border-b border-neutral-200">
          <div class="w-40 font-medium text-sm text-neutral-900">
            {{
              'workflow_configurations_details_screen_when_section_title'
                | transloco
            }}
          </div>

          <div class="flex flex-col gap-md">
            <div class="font-medium text-sm text-neutral-500">
              {{
                'workflow_configurations_details_screen_when_label' | transloco
              }}
            </div>

            <div class="font-medium text-base text-neutral-900">
              @if (stepInfo().when) {
                {{
                  'workflow_configurations_details_screen_based_on_conditions_label'
                    | transloco
                }}
              } @else {
                {{
                  'workflow_configurations_details_screen_always_label'
                    | transloco
                }}
              }
            </div>
          </div>

          @if (stepInfo().when) {
            <div class="flex flex-col gap-md flex-1">
              <div class="font-medium text-sm text-neutral-500">
                {{
                  'workflow_configurations_details_screen_condition_label'
                    | transloco
                }}
              </div>

              <div class="font-medium text-base text-neutral-900">
                {{ stepInfo().when }}
              </div>
            </div>
          }
        </section>

        <!-- Actions -->
        @if (stepInfo().position !== 1) {
          <section class="flex py-lg gap-lg border-b border-neutral-200">
            <div class="w-40 font-medium text-sm text-neutral-900">
              {{
                'workflow_configurations_details_screen_actions_section_title'
                  | transloco
              }}
            </div>
            <div
              class="flex flex-wrap gap-lg w-[calc(100%-10rem)]"
              formGroupName="actions">
              <!-- Send Back -->
              <div class="flex justify-between w-100">
                <div
                  class="font-semibold text-sm"
                  [class.text-neutral-900]="stepInfo().position !== 2"
                  [class.text-neutral-300]="
                    stepInfo().position === 2 && !canBeSentBackToFirstPosition()
                  ">
                  {{
                    'workflow_configurations_details_screen_send_back_label'
                      | transloco
                  }}
                </div>
                <div [class.cursor-not-allowed]="stepInfo().position === 2">
                  <lib-toggle
                    [inputFormControlName]="'send_back'"
                    [formGroup]="actionsForm"
                    [id]="'send_back'"
                    [disabled]="
                      stepInfo().position === 2 &&
                      !canBeSentBackToFirstPosition()
                    "
                    (valueChange)="toggleSendBack($event.toggleValue)" />
                </div>
              </div>

              <!-- Number of Steps -->
              <div class="flex-initial w-full mb-2xl">
                <div class="w-100">
                  <lib-select
                    [inputFormControlName]="'send_back_steps'"
                    [label]="
                      'workflow_configurations_details_screen_number_of_steps_label'
                        | transloco
                    "
                    id="send_back_steps"
                    name="send_back_steps"
                    [options]="sendBackStepsOptions()"
                    [selectedKeyName]="'label'"
                    [disabled]="!actionsForm.get('send_back')?.value"
                    [selectedKeyValue]="'value'"
                    [placeholder]="
                      'workflow_configurations_details_screen_select_number_of_steps_placeholder'
                        | transloco
                    "
                    [required]="true" />

                  <lib-validation-message
                    [lang]="'current_lang' | transloco"
                    control="send_back_steps" />
                </div>
              </div>

              <!-- Reject This Step & Send Forward -->
              <div class="flex justify-between w-100">
                <div class="font-semibold text-sm text-neutral-900">
                  {{
                    'workflow_configurations_details_screen_send_forward_label'
                      | transloco
                  }}
                </div>
                <div>
                  <lib-toggle
                    [inputFormControlName]="'send_forward'"
                    [formGroup]="actionsForm"
                    [id]="'send_forward'" />
                </div>
              </div>

              <!-- Reassign -->
              <div class="flex justify-between w-100">
                <div class="font-semibold text-sm text-neutral-900">
                  {{
                    'workflow_configurations_details_screen_reassign_label'
                      | transloco
                  }}
                </div>
                <div>
                  <lib-toggle
                    [inputFormControlName]="'re_assign'"
                    [formGroup]="actionsForm"
                    [id]="'re_assign'" />
                </div>
              </div>

              <!-- Reject The Request -->
              <div class="flex-initial w-full mt-2xl">
                <div class="flex justify-between w-100">
                  <div class="font-semibold text-sm text-neutral-900">
                    {{
                      'workflow_configurations_details_screen_reject_label'
                        | transloco
                    }}
                  </div>
                  <div>
                    <lib-toggle
                      [inputFormControlName]="'reject'"
                      [formGroup]="actionsForm"
                      [id]="'reject'" />
                  </div>
                </div>
              </div>
            </div>
          </section>
        }

        <!-- WF Actions -->
        @if (
          isAddCollaboratorsStepActionEnabled() &&
          stepActionsForm &&
          hasStepActions()
        ) {
          <section class="flex py-lg gap-lg border-b border-neutral-200">
            <div class="w-40 font-medium text-sm text-neutral-900">
              {{
                'workflow_step_info_form_wf_actions_section_title' | transloco
              }}
            </div>

            <div class="w-[calc(100%-10rem)] flex flex-col gap-lg">
              @for (
                actionGroup of stepActionControls;
                track $index;
                let index = $index
              ) {
                <div
                  class="relative bg-white border border-neutral-200 rounded-lg p-lg flex justify-between gap-lg">
                  <div class="w-full">
                    @let controlId = actionGroup?.controls.id.value;
                    <lib-workflow-configuration-step-action
                      [formGroup]="actionGroup"
                      [actionIndex]="index"
                      [initialSelectedUsers]="
                        controlId != null
                          ? stepActionInitialUsersById()[controlId]
                          : []
                      " />
                    @if (actionGroup.hasError(duplicatedActionError)) {
                      @let duplicatedWithIndex =
                        actionGroup.getError(duplicatedActionError)
                          ?.duplicatedWithIndex;
                      <p
                        class="text-destructive-500 text-sm font-normal mt-sm"
                        role="alert">
                        {{
                          'workflow_step_info_form_duplicated_action_error'
                            | transloco: { index: duplicatedWithIndex }
                        }}
                      </p>
                    }
                  </div>

                  <div>
                    <div class="flex items-center gap-md">
                      <span
                        class="absolute inset-be-0 inset-e-0 min-w-8 min-h-8 rounded-ss-lg rounded-ee-lg flex items-center justify-center bg-primary-50 text-primary-700 text-xs font-medium px-sm py-x-sm">
                        {{ index + 1 }}
                      </span>
                    </div>

                    <button
                      type="button"
                      [title]="
                        'workflow_step_info_form_remove_step_action_button_title'
                          | transloco
                      "
                      [id]="
                        'workflow_step_info_form_remove_step_action_button_' +
                        index
                      "
                      class="bg-transparent border-none cursor-pointer p-0"
                      (click)="removeStepAction(index)">
                      <lib-close-icon [iconClass]="'size-5 text-neutral-500'" />
                    </button>
                  </div>
                </div>
              }

              <button
                type="button"
                id="workflow_step_info_form_add_new_action_button"
                class="w-fit text-primary-600 bg-transparent font-medium text-sm border-none flex gap-sm items-center cursor-pointer p-0 disabled:text-primary-300"
                [disabled]="stepActionsForm.invalid"
                (click)="addStepAction()">
                <lib-add-icon
                  [iconClass]="
                    'size-6' +
                    (stepActionsForm.invalid
                      ? ' text-primary-300'
                      : ' text-primary-500')
                  " />
                {{
                  'workflow_step_info_form_add_new_action_button_label'
                    | transloco
                }}
              </button>
            </div>
          </section>
        }

        <!-- Rename Buttons / Completion Action Section -->
        <section class="flex py-lg gap-lg border-b border-neutral-200">
          <div class="w-40 font-medium text-sm text-neutral-900">
            {{
              'workflow_configurations_details_screen_rename_buttons_section_title'
                | transloco
            }}
          </div>
          <div class="flex flex-wrap gap-lg w-[calc(100%-10rem)]">
            <div class="w-100">
              <lib-select
                [inputFormControlName]="'completion_action'"
                [label]="
                  'workflow_configurations_details_screen_completion_action_label'
                    | transloco
                "
                id="completion_action"
                name="completion_action"
                [options]="completionActionOptions()"
                [selectedKeyName]="'label'"
                [selectedKeyValue]="'value'"
                [placeholder]="
                  'workflow_configurations_details_screen_completion_action_placeholder'
                    | transloco
                "
                [required]="true" />
              <lib-validation-message
                [lang]="'current_lang' | transloco"
                control="completion_action" />
            </div>
          </div>
        </section>

        @if (reflectionsFlowTemplateId(); as flowTemplateId) {
          <!-- Step Reflections Section -->
          <section
            [id]="'workflow_step_reflections_' + stepInfo().id"
            class="flex py-lg gap-lg border-b border-neutral-200">
            <div class="w-40 shrink-0 font-medium text-sm text-neutral-900">
              {{ 'reflection_section_title' | transloco }}
            </div>

            <div class="flex-1 min-w-0">
              <lib-reflection-list
                [flowTemplateId]="flowTemplateId"
                [scope]="Scope.STEP"
                [stepTemplateId]="stepInfo().id"
                [readonly]="false" />
            </div>
          </section>
        }
      </div>
    </lib-accordion>
  </form>
}

<ng-template #type let-type>
  @switch (type) {
    @case ('user') {
      {{
        'workflow_configurations_details_screen_select_user_placeholder'
          | transloco
      }}
    }

    @case ('group') {
      {{
        'workflow_configurations_details_screen_select_group_placeholder'
          | transloco
      }}
    }

    @case ('department') {
      {{
        'workflow_configurations_details_screen_select_department_placeholder'
          | transloco
      }}
    }

    @case ('legal_entity') {
      {{ 'workflow_step_info_form_{legal_entity}_label' | transloco }}
      {{ type }}
    }

    @case ('variable') {
      {{ 'workflow_step_info_form_variable option_label' | transloco }}
    }

    @case ('project_role') {
      {{ 'workflow_step_info_form_select_project_role_label' | transloco }}
    }

    @case ('fields') {
      {{ 'workflow_step_info_form_select_{fields}_label' | transloco }}
    }

    @case ('position') {
      {{ 'workflow_step_info_form_select_{position}_label' | transloco }}
    }
  }
</ng-template>
